import styled from 'styled-components/macro';
import { palette } from '../../styles/constants';

type TabsProps = {
    children?: React.ReactNode;
}

export default function Tabs({ children }: TabsProps) {
    return (
        <Wrapper>
            {children}
        </Wrapper>
    );
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: stretch;
    border-bottom: 1px solid ${palette.neutral[300]};
    @media (max-width: 768px) {
        overflow-x: auto;
        overflow-y: hidden;
        flex-wrap: nowrap;
        margin-inline: -8px;
        min-width: calc(100% + 16px);
        position: relative;
        margin-block-start: 0;
        & > * {
            max-width: max-content;
            min-width: max-content;
        }
    }
`;
